import React, {Component} from "react";
import './InstancesButtons.css'

export default class InstancesButtons extends Component {

    render() {
        if (this.props.loading) {
            return (
                <div>
                    <button className="try-pi-btn btn-create disabled" data-testid="instance.button.create" disabled={true}>CREATE</button>
                    <button className="try-pi-btn btn-refresh" data-testid="instance.button.refresh" disabled={true}>REFRESH</button>
                    <button className="try-pi-btn btn-logout" data-testid="instance.button.logOut" onClick={this.props.logout}>LOG OUT</button>
                </div>
            );
        }
        return (
            <div>
                <button
                    className={`try-pi-btn btn-create`}
                    data-testid="instance.button.create"
                    disabled={!!((!this.props.allowCreation || this.props.requestingPisaasCustomerInstances))}
                    onClick={() => this.props.createTryPiInstance ? this.props.handleSignUp() : this.props.toggleSignUp()}>CREATE</button>
                <button className="try-pi-btn btn-refresh" data-testid="instance.button.refresh" onClick={this.props.load}>REFRESH</button>
                <button className="try-pi-btn btn-logout" data-testid="instance.button.logOut" onClick={this.props.logout}>LOG OUT</button>
            </div>
        );
    }
}